import request from '../request';
// import axios from 'axios';
// 导师后台列表
export const getMentorList = (params) => {
    return request({
        url: '/v3/tasks',
        method: 'get',
        params
    })
}

export const getMentorCardDetail = (id) => {
  return request({
    url: `/v1/mentor_card/${id}`,
    method: 'get',
  })
}